import { render } from "./StoreTargetList.vue?vue&type=template&id=9be0bf82&scoped=true"
import script from "./StoreTargetList.vue?vue&type=script&lang=js"
export * from "./StoreTargetList.vue?vue&type=script&lang=js"

import "./StoreTargetList.vue?vue&type=style&index=0&id=9be0bf82&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be0bf82"]])

export default __exports__